import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { useRouteMatch } from 'react-router-dom'
import { Stack } from '@mui/material'
import { Dialog } from '@trivie/ui-web/components/dialogs/dialog'
import { ISelectorOption, useStores } from '@trivie/core'
import { color } from '@trivie/ui-web/theme/color'
import { Text } from '@trivie/ui-web/components/text'
import { Switch } from '@trivie/ui-web/components/switch/switch'
import { AutocompleteSelector } from '../../../components/autocomplete-selector'

// eslint-disable-next-line
const _array = require('lodash/array')

export interface AddToQuizDialogProps {
  open: boolean
  onClose: () => void
}

export const AddToQuizDialog = observer((props: AddToQuizDialogProps) => {
  const { open, onClose } = props
  const { manageResourceStore } = useStores()
  const { params } = useRouteMatch()
  const { getRelatedQuizzes, relatedQuizzes, addResourceToQuizzes } = manageResourceStore
  const [isRequired, setIsRequired] = useState(false)
  const [selectedOptions, setSelectedOptions] = useState<ISelectorOption[]>([])

  //@ts-ignore
  const { id } = params

  const handleSubmit = () => {
    const targetQuizzes = _array.differenceWith(
      selectedOptions,
      relatedQuizzes,
      (x: ISelectorOption, y: any) => x.id === y.quiz_id,
    ) as { id: number }[]

    const quiz_ids = targetQuizzes.map((val) => val.id)
    addResourceToQuizzes(id, quiz_ids, isRequired).then(() => {
      getRelatedQuizzes(id)
      setSelectedOptions([])
      onClose()
    })
  }

  const handleSelectionChange = (selected: ISelectorOption[]) => {
    setSelectedOptions(selected)
  }

  return (
    <Dialog
      onCancel={onClose}
      onConfirm={handleSubmit}
      confirmBtnLabel="Add Source"
      disableConfirm={selectedOptions.length === 0}
      onClose={onClose}
      title="Add Source to Quiz"
      open={open}
      sx={{
        '& .MuiDialogContent-root': {
          display: 'flex',
          flex: 1,
          overflow: 'hidden',
          maxHeight: 500,
          flexDirection: 'column',
        },
      }}
      maxWidth="sm"
    >
      <Stack
        useFlexGap
        gap={2}
        alignItems="center"
        direction="row"
        mb={2}
        justifyContent="space-between"
      >
        <Stack>
          <Text variant="body1Emphasized" text="Required Source" />
          <Text
            variant="body2"
            text="Require users to view this source before taking the attached quiz"
            style={{ color: color.palette.grey, marginTop: 3 }}
          />
        </Stack>
        <Switch
          color="success"
          checked={isRequired}
          onChange={(e) => setIsRequired(e.target.checked)}
        />
      </Stack>
      <div
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          overflowY: 'hidden',
          height: 500,
        }}
      >
        <AutocompleteSelector
          variant="quizzes"
          open
          noOptionsText="No matching quizzes."
          onSelectionChange={handleSelectionChange}
        />
      </div>
    </Dialog>
  )
})
